import { useCallback, useState, useEffect } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import React from 'react';

export const Particle = () => {
  // Render nothing on the first (hydration) pass so the client DOM matches the
  // prerendered HTML — react-snap captures this null state. Particles mount only
  // AFTER hydration via the effect below, avoiding a hydration mismatch that
  // would make React re-render the whole tree (which left an orphaned canvas at
  // the bottom of the page and broke the navbar layout). The ReactSnap guard
  // keeps the canvas out of the prerendered HTML entirely.
  const [showParticles, setShowParticles] = useState(false);

  useEffect(() => {
    if (navigator.userAgent !== 'ReactSnap') {
      setShowParticles(true);
    }
  }, []);

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async () => {}, []);

  if (!showParticles) {
    return null;
  }

  return (
    <div>
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          fullScreen: false,
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "grab",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              grab: {
                distance: 300,
                links: {
                  opacity: 0.5,
                }
              }
            },
          },
          particles: {
            color: {
              value: "#2a6dff",
            },
            links: {
              color: "#fff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 2,
            },
            move: {
              direction: "none",
              enable: true,
              outModes: {
                default: "bounce",
              },
              random: false,
              speed: 2,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 1500,
              },
              value: 80,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1, max: 4 },
            },
          },
          detectRetina: true,
        }}
      />
    </div>
  );
}
